/* ==========================================================================
   Link para a tela em que a pessoa já está (relatório de UX, P1-12; D3b)

   Um aviso global com "Ver conversas" dentro do Atendimento, ou "Ver pedidos"
   dentro de Pedidos, leva a lugar nenhum. O link some quando aponta para a
   tela atual:
   - sem consulta (`/orders`), vale a própria rota e as filhas dela
     (`/conversations` dentro de `/conversations/abc`), com qualquer consulta;
   - com consulta (`/orders?pedido=42`), só o endereço igual: "Ver pedido"
     abre o detalhe e continua útil dentro de Pedidos.
   ========================================================================== */

export interface RouteLocation {
  pathname: string;
  search: string;
}

export function pointsToCurrentRoute(to: string, location: RouteLocation): boolean {
  const queryAt = to.indexOf('?');
  const path = queryAt === -1 ? to : to.slice(0, queryAt);
  if (queryAt !== -1) return location.pathname === path && location.search === to.slice(queryAt);
  if (path === '/' || path === '') return location.pathname === '/';
  return location.pathname === path || location.pathname.startsWith(`${path.replace(/\/$/, '')}/`);
}
